/**
 * Énumérations structurantes du domaine (sociétés, documents, système).
 * Référence : document 04 § 5.1, § 5.16 et § 5.17 — contraintes `CHECK`.
 */
export const VAT_REGIMES = ['normal', 'franchise', 'autoliq', 'exonere'];
export const ISSUER_STATUSES = ['draft', 'active', 'suspended', 'closed'];
/** Types de documents soumis à numérotation paramétrable (document 04 § 5.1). */
export const NUMBERING_DOCUMENT_TYPES = [
    'quote',
    'order',
    'invoice',
    'credit_note',
    'deposit_invoice',
    'progress_invoice',
    'final_invoice',
    'prospect',
    'client',
];
export const JOB_QUEUES = [
    'default',
    'pdf',
    'mail',
    'banking',
    'e_invoicing',
    'signature',
    'reports',
];
export const JOB_STATUSES = [
    'pending',
    'running',
    'succeeded',
    'failed',
    'dead',
    'cancelled',
];
export const PLATFORM_SCOPES = ['platform', 'tenant'];
//# sourceMappingURL=platform.enum.js.map